/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdjustmentsConfigDto } from './AdjustmentsConfigDto';
import {
    AdjustmentsConfigDtoFromJSON,
    AdjustmentsConfigDtoFromJSONTyped,
    AdjustmentsConfigDtoToJSON,
    AdjustmentsConfigDtoToJSONTyped,
} from './AdjustmentsConfigDto';
import type { LoanConfigWithGuaranteeIdsDto } from './LoanConfigWithGuaranteeIdsDto';
import {
    LoanConfigWithGuaranteeIdsDtoFromJSON,
    LoanConfigWithGuaranteeIdsDtoFromJSONTyped,
    LoanConfigWithGuaranteeIdsDtoToJSON,
    LoanConfigWithGuaranteeIdsDtoToJSONTyped,
} from './LoanConfigWithGuaranteeIdsDto';

/**
 * 
 * @export
 * @interface GetBorrowerContractFunnelsCommand
 */
export interface GetBorrowerContractFunnelsCommand {
    /**
     * 
     * @type {AdjustmentsConfigDto}
     * @memberof GetBorrowerContractFunnelsCommand
     */
    adjustmentsConfig: AdjustmentsConfigDto;
    /**
     * 
     * @type {Array<LoanConfigWithGuaranteeIdsDto>}
     * @memberof GetBorrowerContractFunnelsCommand
     */
    loanConfigs: Array<LoanConfigWithGuaranteeIdsDto>;
}

/**
 * Check if a given object implements the GetBorrowerContractFunnelsCommand interface.
 */
export function instanceOfGetBorrowerContractFunnelsCommand(value: object): value is GetBorrowerContractFunnelsCommand {
    if (!('adjustmentsConfig' in value) || value['adjustmentsConfig'] === undefined) return false;
    if (!('loanConfigs' in value) || value['loanConfigs'] === undefined) return false;
    return true;
}

export function GetBorrowerContractFunnelsCommandFromJSON(json: any): GetBorrowerContractFunnelsCommand {
    return GetBorrowerContractFunnelsCommandFromJSONTyped(json, false);
}

export function GetBorrowerContractFunnelsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBorrowerContractFunnelsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'adjustmentsConfig': AdjustmentsConfigDtoFromJSON(json['adjustmentsConfig']),
        'loanConfigs': ((json['loanConfigs'] as Array<any>).map(LoanConfigWithGuaranteeIdsDtoFromJSON)),
    };
}

export function GetBorrowerContractFunnelsCommandToJSON(json: any): GetBorrowerContractFunnelsCommand {
    return GetBorrowerContractFunnelsCommandToJSONTyped(json, false);
}

export function GetBorrowerContractFunnelsCommandToJSONTyped(value?: GetBorrowerContractFunnelsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adjustmentsConfig': AdjustmentsConfigDtoToJSON(value['adjustmentsConfig']),
        'loanConfigs': ((value['loanConfigs'] as Array<any>).map(LoanConfigWithGuaranteeIdsDtoToJSON)),
    };
}

